import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'smatchy-search-city-page',
  templateUrl: './search-city-page.component.html',
  styleUrls: ['./search-city-page.component.scss'],
  standalone: false,
})
export class SearchCityPageComponent implements OnInit {
  @Input() rayon?: number;
  @Input() formattedAddress?: string;
  @Input() country?: string;
  @Input() city?: string;
  @Input() region?: string;
  @Input() lat?: number;
  @Input() lng?: number;
  @Input() returnToModal?: string;
  @Input() groupId?: string;
  @Input() groupName?: string;

  saveUser = false;

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _router: NavController,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    if (!this.rayon && !this.city) {
      // Every caller (Explorer, the search home, the search results) navigates
      // with matrix parameters, `['/home/search/city', { rayon, city, ... }]`,
      // which Angular puts in `params`. The page read only `queryParams`, so
      // it always opened empty and never offered to keep the place (found on
      // 29/10/2026). Both are read; a matrix value wins.
      const sent = { ...this._activatedRoute.snapshot.queryParams, ...this._activatedRoute.snapshot.params };
      this.rayon = sent['rayon'] ? parseFloat(sent['rayon']) : undefined;
      this.formattedAddress = sent['formattedAddress'];
      this.country = sent['country'];
      this.city = sent['city'];
      this.region = sent['region'];
      this.lat = sent['lat'] ? parseFloat(sent['lat']) : undefined;
      this.lng = sent['lng'] ? parseFloat(sent['lng']) : undefined;
    }

    if (this.city && this.country && this.formattedAddress && this.region && this.lat && this.lng) {
      this.saveUser = true;
    }
  }

  onSaved(event: { saved: boolean }) {
    if (event.saved) {
      this._router.back();
    }
  }
}
